/** @jsxImportSource @emotion/react */
import { SerializedStyles } from "@emotion/react";
import { MODAL_SIZE } from "../layout/modal/modalSize";
import ModalView, { ModalContent } from "../layout/modal/ModalView";
import { useSelector } from "react-redux";
import { IAppState } from "../core/redux/IAppState";
import { getResource } from "../language/resources/getResource";
import { COLUMN_SPACING } from "../forms/styles";
import ModalTitleHeader from "../layout/modal/ModalTitleHeader";
import editIcon from "../assets/icons/edit.svg";
import { LiftAccessRuleSetCreator } from "./accessRules/liftAccessRuleSet/LiftAccessRuleSetCreator";
import { AccessOverviewQuery, FulfillmentSeason, SellingSeason } from "./models";
import { EntitlementType } from "../entitlementTypes/entitlementType";
import { Resort } from "../resortDetails/resort";

type Props = {
  sellingSeasons: SellingSeason[];
  fulfillmentSeasons: FulfillmentSeason[];
  entitlementTypes: EntitlementType[];
  resorts: Resort[];
  onCommit?: (query: AccessOverviewQuery) => void;
  dismissable?: boolean;
  onDismiss: () => void;
  rootCss?: SerializedStyles;
};

export const AccessMultiCreateModal = (props: Props) => {
  const resources = useSelector((state: IAppState) => state.locale);

  return (
    <ModalView
      dismissable={props.dismissable}
      onDismiss={props.onDismiss}
      disableClickoffDismissable={true}
      rootCss={props.rootCss}
      size={MODAL_SIZE.LARGE}
      contentCss={COLUMN_SPACING}
    >
      <ModalTitleHeader
        resources={resources}
        heading={getResource(resources, "ACCESS_RULE_ADD_MODAL_TITLE")}
        icon={editIcon}
        onDismiss={props.onDismiss}
      />
      <ModalContent>
        <LiftAccessRuleSetCreator
          sellingSeasons={props.sellingSeasons}
          fulfillmentSeasons={props.fulfillmentSeasons}
          entitlementTypes={props.entitlementTypes}
          resorts={props.resorts}
          onDismiss={props.onDismiss}
          onCreate={props.onCommit}
        />
      </ModalContent>
    </ModalView>
  );
};
